import React, { Fragment, useState, useEffect, useMemo, useRef } from "react"
import PropTypes from "prop-types"
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, } from "react-table"
import { Table, Row, Col, Button, Input, CardBody, Spinner } from "reactstrap"
// import { Filter, DefaultColumnFilte}
// import JobListGlobalFilter from "../../components/Common/GlobalSearchFilter"
import { useSelector, useDispatch } from "react-redux"
import { firstPage, firstPageUser, getPublicacao, getPublicacoesPendentes, lastPage, lastPageUser, nextPage, nextPageUser, previousPage, previousPageUser, setCNJValue, } from "store/actions"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import { DefaultColumnFilter, Filter } from "./filters"

// Define a default UI for filtering
function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter, isJobListGlobalFilter, handleQualificacaoClick, loading, setLoading, selectedFilters, setStartPanel, totalCount, storedFilters, localPageIndex, pageSize, setNumberProcess, notFoundProcess }) {
  const count = preGlobalFilteredRows.length
  const dispatch = useDispatch()
  

  const loadingRedux = useSelector(state => state.Publicacao.loading)
  const [value, setValue] = React.useState(globalFilter)

  const onChange = useAsyncDebounce(value => {
    console.log("onChange - value", value)
    if (notFoundProcess) {
      setLoading(false)
    }
    if (value === "") {
      dispatch(
        getPublicacoesPendentes({
          filtros: { Status: [1], Prioridade: ["1"], Data: "todasdatas" },
          page: localPageIndex === 0 ? 1 : localPageIndex,
          pageSize: pageSize,
        })
      )
    }

    if (value.length >= 10) {
      setNumberProcess(value)
      setStartPanel(true)
      dispatch(setCNJValue(value))
      dispatch(getPublicacao(value))
    }
  }, 100)

  useEffect(() => {
    setLoading(loadingRedux)
  }, [loadingRedux])

  const handleInputChange = e => {
    const inputValue = e.target.value
    console.log("HANDLE INPUT CHANGE - INPUT VALUE", inputValue)
    setValue(inputValue)
    onChange(inputValue)

    if (inputValue === "") {
      setLoading(true)
    }
  }

  return (
    <React.Fragment>
      <Col md={4}>
        <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
          {/* <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Procurar na tabela
              </span>
              <input onChange={handleInputChange} id="search-bar-0" type="text" className="form-control" placeholder={`${totalCount} registros...`} value={value || ""} />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div> */}
        </div>
      </Col>
    </React.Fragment>
  )
}

const TableContainer = ({ columns, data, isGlobalFilter, isJobListGlobalFilter, handleOrderClicks, handleUserClick, handleCustomerClick, handleQualificacaoClick, loading, setLoading, selectedFilters, setFilters, customPageSize, className, startPanel, setStartPanel, setPageSizeClick }) => {
  const memoizedData = useMemo(() => data, [data]);
const memoizedColumns = useMemo(() => columns, [columns]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: memoizedColumns,
    data: memoizedData,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        // sortBy: [
        //   {
        //     desc: false,
        //   },
        // ],
      },
      autoResetFilters: false, // Prevent resetting filters
      autoResetPage: false,
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const dispatch = useDispatch()
  const { currentPageIndex, totalCount, totalpage, error } = useSelector(
    state => state.contacts
  )
  const [localPageIndex, setLocalPageIndex] = useState(1)
  const [numberProcess, setNumberProcess] = useState("")
  const initialRender = useRef(true);

  // const storedFilters = JSON.parse(localStorage.getItem("pendingFilter"))
  // const filtersToUse = storedFilters || selectedFilters

  const totalPages = Math.ceil(data.length / pageSize)
  const totalItems = data.length;






  const storedFilters = useMemo(() => JSON.parse(localStorage.getItem("pendingFilter")), []);
const filtersToUse = useMemo(() => storedFilters || selectedFilters, [storedFilters, selectedFilters]);


useEffect(() => {
  if (!initialRender.current) {
    dispatch(
      getPublicacoesPendentes({
        filtros: filtersToUse,
        page: localPageIndex === 0 ? 1 : localPageIndex,
        pageSize: pageSize,
      })
    );
  } else {
    initialRender.current = false;
  }
}, [localPageIndex, pageSize, filtersToUse, dispatch]);


  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""
  }

  const onChangeInSelect = event => {
    setLoading(true);
    setLocalPageIndex(1);
    setPageSize(Number(event.target.value));
    setPageSizeClick(Number(event.target.value));
  
    // Set loading and startPanel here
    setStartPanel(true);
    setLoading(false)
  };

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    setLocalPageIndex(page)
    gotoPage(page)
  }

  // const handleNextPage = () => {
  //   const nextPageIndex = localPageIndex + 1;
  //   dispatch(nextPageUser());
  //   setLocalPageIndex(nextPageIndex);
  //   gotoPage(nextPageIndex);
  
  //   // Set loading and startPanel here
  //   // setLoading(true);
  //   setStartPanel(true);
  // };

  // const handlePreviousPage = () => {
  //   if (localPageIndex > 0) {
  //     const previousPageIndex = localPageIndex - 1
  //     dispatch(previousPageUser())
  //     setLocalPageIndex(previousPageIndex)
  //     gotoPage(previousPageIndex)
  //   }
  // }

  // const handleFirstPage = () => {
  //   if (localPageIndex !== 0) {
  //     dispatch(firstPageUser())
  //     setLocalPageIndex(1)
  //     gotoPage(1)
  //   }
  // }

  // const handleLastPage = () => {
  //   const lastIndex = totalPages
  //   if (localPageIndex !== lastIndex) {
  //     dispatch(lastPageUser())
  //     setLocalPageIndex(lastIndex)
  //     gotoPage(lastIndex)
  //   }
  // }

  const paginatedData = useMemo(() => {
    const startIndex = localPageIndex * pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);  // Mostra apenas os itens da página atual
  }, [data, localPageIndex, pageSize]);

  const handleNextPage = () => {
    if (canNextPage) {  // Verifica se há uma próxima página
      const nextPageIndex = localPageIndex + 1;
      setLocalPageIndex(nextPageIndex); 
      gotoPage(pageIndex + 1);  // Altera para a próxima página
    }
  };
  
  const handlePreviousPage = () => {
    if (canPreviousPage) {  // Verifica se há uma página anterior
      const nextPageIndex = localPageIndex - 1;
      setLocalPageIndex(nextPageIndex); 
      gotoPage(pageIndex - 1);  // Altera para a página anterior
    }
  };
  
  const handleFirstPage = () => {
    const firstPageIndex = 0;  // A primeira página é 0 no react-table
    setLocalPageIndex(firstPageIndex + 1);  // Ajusta o localPageIndex para exibir corretamente a página 1
    gotoPage(firstPageIndex);  // Vai para a página 0 no react-table
  };
  
  const handleLastPage = () => {
    const lastPageIndex = pageCount - 1;  // A última página é pageCount - 1
    setLocalPageIndex(lastPageIndex + 1);  // Ajusta o localPageIndex para refletir corretamente a última página
    gotoPage(lastPageIndex);  // Vai para a última página
  };



  

























  const notFoundProcess = error?.response?.status

  return (
    <Fragment>
      <Row className="mb-2 justify-content-between">
        {isGlobalFilter && (
          <Col md={6} className="mb-2 mb-md-0">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
              isJobListGlobalFilter={isJobListGlobalFilter}
              handleQualificacaoClick={handleQualificacaoClick}
              loading={loading}
              setLoading={setLoading}
              selectedFilters={selectedFilters}
              setStartPanel={setStartPanel}
              totalCount={data.length}
              storedFilters={storedFilters}
              localPageIndex={localPageIndex}
              pageSize={pageSize}
              setNumberProcess={setNumberProcess}
              notFoundProcess={notFoundProcess}
            />
          </Col>
        )}
        <Col md={2} className="text-end">
          <select
            className="form-select"
            value={pageSize}
            onChange={onChangeInSelect}
          >
            {[10, 20, 30, 40, 50, 100].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Exibir {pageSize}
              </option>
            ))}
          </select>
        </Col>
      </Row>

      {isJobListGlobalFilter && (
        <Row>
          <JobListGlobalFilter
            loading={loading}
            selectedFilters={selectedFilters}
            setFilters={setFilters}
            onSearchClick={handleQualificacaoClick}
            setStartPanel={setStartPanel}
          />
        </Row>
      )}

      {notFoundProcess && !loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ padding: 20, fontSize: "1.3em", fontWeight: "500" }}>
            Nenhum usuário encontrado
          </div>
        </div>
      ) : (
        <>
          {!loading && data.length === 0 && startPanel ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{ padding: 20, fontSize: "1.3em", fontWeight: "500" }}
              >
                Não foram encontrados dados cadastrados.
              </div>
            </div>
          ) : (
            <>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <Spinner
                    color="primary"
                    style={{
                      height: "3rem",
                      width: "3rem",
                    }}
                  >
                    Loading...
                  </Spinner>
                </div>
              ) : (
                <>
                  {!startPanel && data.length === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          padding: 20,
                          fontSize: "1.3em",
                          fontWeight: "500",
                        }}
                      >
                        Nenhum resultado foi encontrado para a pesquisa
                        selecionada.
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive react-table">
                      <Table
                        bordered
                        hover
                        {...getTableProps()}
                        className={className}
                      >
                        <thead className="table-light table-nowrap">
                          {headerGroups.map(headerGroup => (
                            <tr
                              key={headerGroup.id}
                              {...headerGroup.getHeaderGroupProps()}
                            >
                              {headerGroup.headers.map(column => (
                                <th key={column.id}>
                                  <div
                                    className="mb-2"
                                    {...column.getSortByToggleProps()}
                                  >
                                    {column.render("Header")}
                                    {generateSortingIndicator(column)}
                                  </div>
                                  <Filter column={column} />
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>

                        <tbody {...getTableBodyProps()}>
                          {page.map(row => {
                            console.log("Row", row)
                            prepareRow(row)
                            return (
                              <Fragment key={row.getRowProps().key}>
                                <tr>
                                  {row.cells.map(cell => (
                                    <td key={cell.id} {...cell.getCellProps()}>
                                      {cell.render("Cell")}
                                    </td>
                                  ))}
                                </tr>
                              </Fragment>
                            )
                          })}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={handleFirstPage}
              disabled={localPageIndex <= 1}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              onClick={handlePreviousPage}
              disabled={localPageIndex <= 1}
            >
              {"<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          página{" "}
          <strong>
            {localPageIndex} de {totalPages}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            max={totalPages}
            value={localPageIndex}
            onChange={onChangeInInput}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={handleNextPage}
              disabled={localPageIndex >= totalPages}
            >
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={handleLastPage}
              disabled={localPageIndex >= totalPages}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TableContainer

